import { ApolloClient } from '@apollo/client';
import { getDealById } from '../../../api/queries';
import { graphql } from '../../../gql';

type ResponsePayloadType = {
  success: boolean;
};

type Props = {
  documentId: string;
  dealId: string | number;
  viewerIds: string[];
  additionalMessage?: string | null;
};

export function createDocumentViewRequest({ documentId, viewerIds, dealId, additionalMessage }: Props) {
  return function (client: ApolloClient<object>): Promise<ResponsePayloadType> {
    const variables = {
      documentId,
      viewerIds,
      confirm: true,
      additionalMessage,
    };

    const mutation = graphql(/* GraphQL */ `
      mutation createDocumentViewRequest(
        $documentId: ID!
        $viewerIds: [ID!]!
        $confirm: Boolean
        $additionalMessage: String
      ) {
        createDocumentViewRequest(
          documentId: $documentId
          viewerIds: $viewerIds
          confirm: $confirm
          additionalMessage: $additionalMessage
        ) {
          document {
            id
          }
        }
      }
    `);

    const refetchQueries = [
      {
        query: getDealById,
        variables: {
          dealId,
        },
      },
    ];

    return client
      .mutate({ mutation: mutation as any, variables, refetchQueries })
      .then(({ data }: Record<any, any>) => data.createDocumentViewRequest);
  };
}
